import { Box, Container } from '@mui/material'
import GeroiYaroslavii from "../../icons/geroiYaroslavii.png"


const LogoMain = () => {
    return (
        <>
            <Container maxWidth='xlp'>
                <Box sx={{
                    width: '100%',
                    backgroundImage: `url(${GeroiYaroslavii})`,
                    backgroundPosition: 'center',
                    position: 'relative',
                    backgroundSize: {
                        xs: 'auto 140%',
                        sm: 'auto 120%',
                        md: 'auto 100%',
                        xl: 'cover',
                    },
                    height: {
                        xs: 'calc((751 / 1600) * 100vw)',
                        xl: '751px',
                    },
                }}
                />
            </Container>
        </>
    )
}

export default LogoMain
